import { DateTime } from 'luxon';
export var getFormattedTime = function (datestring, units, timezone) {
    var locale = units === 'metric' ? 'de-DE' : 'en-US';
    return DateTime.fromISO(datestring, { zone: timezone }).setLocale(locale).toLocaleString(DateTime.TIME_SIMPLE);
};
export var getFormattedDate = function (datestring, units, timezone) {
    var locale = units === 'metric' ? 'de-DE' : 'en-US';
    return DateTime.fromISO(datestring, { zone: timezone }).setLocale(locale).toLocaleString(DateTime.DATE_SHORT);
};
